export default "__VITE_ASSET__DZhLA7XC__"